export const ROUTES = {
  edit: (id: string) => `/sales-enablement/my-marketing-materials/${id}`,
  newMaterial: (id: string) =>
    `/sales-enablement/my-marketing-materials/new/${id}`,
};
